/* ============
 * Section-header Component
 * ============
 *
 * todo: add documentation here!
 */

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/section-header/section-header.js